import { getSignalRHubUrlForEnv } from '../consts';
import { bidhubBaseUrl } from '../env';
import { appInsights } from '../services/appinsights.service';
import { AUCTION_EVENTS } from '../event_bus_modules/auction_bidding';
import { NOTIFICATIONS, NOTIFICATION_TYPE } from './notifications';
import { DEFAULT_TIMEOUT } from './utils';

const createScopedHubHandlers = ({
  hub,
  auctionPropertyId,
  userBidderId,
  connectToHub,
  reloadPage,
}) => {
  let tryingToReconnect = false;
  let stopped = false;

  const reconnecting = () => {
    // if hub is connecting we don't want to show reconnecting notification
    if (hub.state === $.signalR.connectionState.connecting) {
      return;
    }

    EVENT_BUS.dispatch(AUCTION_EVENTS.SHOW_NOTIFICATION, {
      notification: NOTIFICATIONS.RECONNECTING,
      type: NOTIFICATION_TYPE.WARNING,
    });
    appInsights.trackEvent({
      name: 'Reconnecting',
      properties: {
        AuctionPropertyId: auctionPropertyId,
        Message: 'Connection Interrupted - Retrying',
        BidderId: userBidderId,
      },
    });
    tryingToReconnect = true;
  };

  const reconnected = () => {
    EVENT_BUS.dispatch(AUCTION_EVENTS.SHOW_NOTIFICATION, {
      notification: NOTIFICATIONS.RECONNECTED,
      type: NOTIFICATION_TYPE.SUCCESS,
    });
    EVENT_BUS.dispatch(AUCTION_EVENTS.CONNECTION_ESTABLISHED, {
      timeout: DEFAULT_TIMEOUT,
    });
    appInsights.trackEvent({
      name: 'Reconnected',
      properties: {
        AuctionPropertyId: auctionPropertyId,
        Message: 'Connection Restored',
        BidderId: userBidderId,
      },
    });
    tryingToReconnect = false;
  };

  const connectionSlow = () => {
    EVENT_BUS.dispatch(AUCTION_EVENTS.SHOW_NOTIFICATION, {
      notification: NOTIFICATIONS.CONNECTION_SLOW,
      type: NOTIFICATION_TYPE.WARNING,
    });
    appInsights.trackEvent({
      name: 'Connection Slow',
      properties: {
        AuctionPropertyId: auctionPropertyId,
        Message: 'Connection Slow',
        BidderId: userBidderId,
      },
    });
  };

  const disconnected = () => {
    if (stopped) {
      return;
    }

    if (tryingToReconnect) {
      //While trying to reconnect, let's not refresh the page.
      EVENT_BUS.dispatch(AUCTION_EVENTS.SHOW_NOTIFICATION, {
        notification: NOTIFICATIONS.RECONNECTING,
        type: NOTIFICATION_TYPE.WARNING,
      });
      appInsights.trackEvent({
        name: 'Reconnecting',
        properties: {
          AuctionPropertyId: auctionPropertyId,
          Message: 'Connection Interrupted - Retrying',
          BidderId: userBidderId,
        },
      });
      setTimeout(connectToHub, DEFAULT_TIMEOUT);

      return;
    }

    EVENT_BUS.dispatch(AUCTION_EVENTS.SHOW_NOTIFICATION, {
      notification: NOTIFICATIONS.CONNECTION_LOST,
      type: NOTIFICATION_TYPE.ERROR,
    });
    appInsights.trackEvent({
      name: 'Connection Lost',
      properties: {
        AuctionPropertyId: auctionPropertyId,
        Message: 'Connection Failed - Reloading',
        BidderId: userBidderId,
      },
    });
    setTimeout(reloadPage, DEFAULT_TIMEOUT);
  };

  const error = () => {
    EVENT_BUS.dispatch(AUCTION_EVENTS.SHOW_NOTIFICATION, {
      notification: NOTIFICATIONS.CONNECTION_LOST,
      type: NOTIFICATION_TYPE.ERROR,
    });
    appInsights.trackEvent({
      name: 'Connection Lost',
      properties: {
        AuctionPropertyId: auctionPropertyId,
        Message: 'Connection Failed - Reloading',
        BidderId: userBidderId,
      },
    });
    setTimeout(reloadPage, DEFAULT_TIMEOUT);
  };

  const stop = () => {
    stopped = true;
  };

  return {
    reconnecting,
    reconnected,
    connectionSlow,
    disconnected,
    error,
    stop,
  };
};

export const hubUrl = getSignalRHubUrlForEnv(bidhubBaseUrl);

export default createScopedHubHandlers;
